import {eatalianoAxios} from "@/data/api/http/axios";
import {Message} from "@/data/entities/message";
import {RestaurantSyncStatus} from "@/data/entities/sync";

export const syncMenu = (restaurantId: number): Promise<Message> => (
    eatalianoAxios
        .put(`/admin/sitedish/sync/${restaurantId}/menu`)
        .then(response => response.data)
);

export const getSynchronizationStatus = (): Promise<RestaurantSyncStatus> => (
    eatalianoAxios
        .get("/admin/sitedish/sync/status")
        .then(response => response.data)
);

export const deleteSynchronizationLogs = (): Promise<Message> => (
    eatalianoAxios
        .delete("/admin/sitedish/sync/logs")
        .then(response => response.data)
);
